<template>
  <div class="hp-manager-page-list">
    <filter-form :filter="filter" @handleSubmit="handleSubmit">
      <span v-if="permissionArray.find(a => a.name=='Dictionary.Create')" slot="button">
        <a-button type="primary" @click="handleEdit(0)">新增</a-button>
      </span>
    </filter-form>
    <standard-table ref="datas" size="default" :bordered="true" :columns="columns" :indentSize="15" :dataSource="datas" :pagination="pagination" :loading="loading" @tableChange="tableChange">
      <template slot="selfactions" slot-scope="rowKey">
        <span>
          <a @click="handleEdit(1,rowKey.data)" :disabled="!(rowKey.data.dictionaryType==2 || rowKey.data.dictionaryType==5) || !permissionChecker('Dictionary.Edit')">编辑</a>
          <a-divider type="vertical" />
          <a href="javascript:;" @click="deldata(rowKey.data)" :disabled="!(rowKey.data.dictionaryType==2 || rowKey.data.dictionaryType==5) ||  !permissionChecker('Dictionary.Delete')">删除</a>
        </span>
      </template>
      <template slot="statusSwitch" slot-scope="rowKey">
        <span>
          <a-switch v-model="rowKey.data.isActive" @change="activeChange(rowKey.data)" :disabled="!(rowKey.data.dictionaryType==2 || rowKey.data.dictionaryType==5) ||  !permissionChecker('Dictionary.Edit') || !permissionChecker('Dictionary.Create')" />
        </span>
      </template>
    </standard-table>

    <!-- 新增修改弹窗 -->
    <hp-manager-modal :width="modalWidth" :title="title" v-model="addVisible">
      <hp-manager-page-dictionary-add slot="slot" @submit-success="refreshCurrent" @cancel="addVisible = false" :params="params"></hp-manager-page-dictionary-add>
    </hp-manager-modal>
  </div>
</template>

<script>
import { api } from "@/common";

import account from "@/mixins/account";
import dateFormat from "@/mixins/dateFormat";
import moneyFormat from "@/mixins/moneyFormat";
import { watch } from "fs";
import hpManagerPageDictionaryAdd from "./Add";
import config from "@/config";
import { setTimeout } from "timers";

export default {
  mixins: [account, dateFormat, moneyFormat],
  components: {
    hpManagerPageDictionaryAdd
  },
  data() {
    return {
      filter: [
        {
          type: "input",
          key: "name",
          name: "字典名称"
        },
        {
          type: "select",
          key: "dictionaryType",
          name: "字典类型",
          options: [
            { name: "计量单位", val: 1 },
            { name: "通知类型", val: 2 },
            { name: "客户类别", val: 3 },
            { name: "产品系列", val: 4 },
            // { name: "活动类型", val: 5 },
            { name: "组织形态", val: 6 },
            { name: "对账类型", val: 7 },
            { name: "销售类型", val: 8 }
          ]
        },
        {
          type: "select",
          key: "isActive",
          name: "状态",
          options: [{ name: "启用", val: 1 }, { name: "禁用", val: 0 }]
        }
      ],
      columns: [
        {
          title: "操作",
          dataIndex: "action",
          width: 120,
          scopedSlots: { customRender: "action" }
        },
        {
          title: "字典类型",
          width: 180,
          dataIndex: "DictionaryType",
          sorter: true,
          customRender: (text, row, index) => {
            return row.dictionaryTypeDes;
          }
        },
        {
          title: " 字典名称",
          // width: 150,
          dataIndex: "name",
          sorter: true
        },
        {
          title: " 字典值",
          width: 400,
          dataIndex: "value",
          sorter: true
        },
        {
          title: "修改时间",
          width: 150,
          dataIndex: "creationTime",
          customRender: (text, row, index) => {
            return row.lastModificationTime != null
              ? this.formatDate(row.lastModificationTime, "YYYY-MM-DD HH:mm:ss")
              : this.formatDate(row.creationTime, "YYYY-MM-DD HH:mm:ss");
          }
        },
        {
          title: "状态",
          width: 100,
          dataIndex: "status",
          scopedSlots: { customRender: "status" }
        }
      ],
      datas: [],
      filterdata: Object.assign(
        { name: "", dictionaryType: null, isActive: null },
        JSON.parse(JSON.stringify(config.pageFilter))
      ),
      pagination: JSON.parse(JSON.stringify(config.page)),
      params: {},
      addVisible: false,
      maxResultCount: config.page.pageSize,
      loading: false,
      pageSizeOptions: config.page.pageSizeOptions,
      modalWidth: "500px",
      permissionArray: [],
      title: ""
    };
  },
  async mounted() {
    this.getDatas(this.filterdata);
    // console.log("permissionChecker('Dictionary.Edit')",this.permissionChecker('Dictionary.Edit'))
    //  console.log("permissionArray.find(a => a.name=='Dictionary.Edit')",this.permissionArray.find(a => a.name=='Dictionary.Edit').length>0);
    this.permissionArray = this.getPermission("Dictionary");
  },
  methods: {
    handleSubmit(p) {
      this.pagination.current = 0;
      this.filterdata.name = p.values.name;
      this.filterdata.dictionaryType = p.values.dictionaryType;
      this.filterdata.isActive =
        p.values.isActive == 1 ? true : p.values.isActive == 0 ? false : null;
      this.filterdata.skipCount = 0;
      this.filterdata.maxResultCount = this.maxResultCount;
      this.getDatas(this.filterdata);
    },
    async activeChange(record) {
      let active = await api.ActiveDictionary({ id: record.id });
    },
    //弹出编辑 详情 新增 模态框
    handleEdit(type, record) {
      this.isabl = false;
      if (type == 1) {
        this.title = "编辑字典";
      } else if (type == 2) {
        this.title = "字典详情";
        this.isabl = true;
      } else {
        this.title = "新增字典";
      }
      this.params = Object.assign({ isShow: this.isabl }, record);
      this.addVisible = true;
    },
    //删除数据
    async deldata(row) {
      let that = this;
      new Promise(async (resolve, reject) => {
        this.$confirm({
          title: "警告",
          content: "确定要删除此数据?",
          okText: "删除",
          centered: "centered",
          okType: "danger",
          cancelText: "取消",
          onOk() {
            that.delHandle(row);
          },
          onCancel() {
            console.log("Cancel");
          }
        });
      });
    },
    async delHandle(row) {
      let msgRet = await api.DelDictionary({ id: row.id });
      if (msgRet) {
        this.$message.success("删除成功");
        if (
          this.pagination.total - 1 <=
          this.pagination.pageSize * (this.pagination.current - 1)
        ) {
          this.filterdata.skipCount =
            this.pagination.current == 1
              ? 0
              : (this.pagination.current - 2) * this.maxResultCount;
          this.pagination.current =
            this.pagination.current == 1 ? 1 : this.pagination.current - 1;
        }
        this.getDatas(this.filterdata);
      }
    },

    refreshCurrent() {
      this.pagination.current = 0;
      this.addVisible = !this.addVisible;
      this.filterdata.skipCount = 0;
      this.filterdata.maxResultCount = this.maxResultCount;
      this.getDatas(this.filterdata);
    },
    tableChange(table) {
      if (table.page) {
        this.pagination.current = table.page.current;
        this.pagination.pageSize = table.page.pageSize;
        this.maxResultCount = table.page.pageSize;
        this.filterdata.skipCount =
          table.page.current == 1
            ? 0
            : (table.page.current - 1) * this.maxResultCount;
        this.filterdata.maxResultCount = table.page.pageSize;
      }
      if (table.sorter.field) {
        this.filterdata.sorting =
          table.sorter.field +
          " " +
          (table.sorter.order == "ascend" ? "asc" : "desc");
      }
      this.getDatas(this.filterdata);
    },

    async getDatas(options) {
      this.loading = true;
      let data = await api.GetDictionaryList(options);
      this.datas = data.items;
      if (data) {
        this.pagination.total = data.totalCount;
        this.pagination.showTotal = bbb => `共有 ${data.totalCount} 条`;
        this.pagination.pageSize = this.maxResultCount;
      }
      this.loading = false;
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/router/Admins/Dictionary/List.vue